import React from "react";
import LoginNavy from "@/pages/LoginNavy";
import LoginPurple from "@/pages/LoginPurple";
import LoginFiord from "@/pages/LoginFiord";
import { useTheme } from "@/lib/uiTheme";

/** Autentificarea, în aspectul ales (ultimul folosit în acest browser, altfel implicitul instalării). */
export default function Login() {
  const theme = useTheme();
  if (theme === "fiord") return <LoginFiord />;
  return theme === "purple" ? <LoginPurple /> : <LoginNavy />;
}
